import { memo } from 'react';

import { Button } from 'UIPackage/MainModule/components/Button';

import styles from './ExportPanel.module.scss';

interface IExportPanelProps {
  isDeleteButtonEnabled?: boolean;
  onReload: () => void;
  onDelete: () => void;
}

export const ExportPanel = memo(({ isDeleteButtonEnabled, onReload, onDelete }: IExportPanelProps) => (
  <div className="shared-panel-container">
    <div className={styles.Actions}>
      <Button startIcon={styles.ReloadIcon} text="Обновить" onClick={onReload} />
      <Button
        className={styles.DeleteButton}
        startIcon={styles.DeleteIcon}
        text="Удалить"
        id="deleteButton"
        onClick={onDelete}
        disabled={!isDeleteButtonEnabled}
      />
    </div>
  </div>
));
